import { useState } from "react";
import InputText from "@/components/InputText/InputText";
import Button from "@/components/Button/Button";
import { FormMessage } from "@/components/FormMessage/FormMessage";
import logo from "@/assets/logo.svg";
import * as S from "./Register.styles";

export function Register() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<[string, boolean] | null>(null);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const formData = new FormData(e.currentTarget);
      const body = {
        username: formData.get("username"),
        email: formData.get("email"),
        phone: formData.get("phone"),
        bollywood: formData.get("bollywood") === "on",
        anime: formData.get("anime") === "on",
      };

      const response = await fetch("/v1/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Registration failed");
      }

      setSubmitted(true);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Registration failed";
      setMessage([message, false]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.Page>
      <S.Card>
        <S.Brand><img src={logo} alt="" /><span>Embark</span></S.Brand>
        {submitted ? (
          <S.Confirmation>
            <h1>Request submitted</h1>
            <p>An admin will review your request. You'll get an email with a link to set your password once you're approved.</p>
          </S.Confirmation>
        ) : (
          <S.Form onSubmit={handleSubmit}>
            <h1>Request access</h1>
            <p className="subtitle">Tell us a bit about yourself to get onboarded.</p>
            <InputText
              label="Username"
              id="username"
              name="username"
              autoComplete="username"
              type="text"
              placeholder="jdoe"
              required
            />
            <InputText
              label="Email"
              id="email"
              name="email"
              autoComplete="email"
              type="email"
              placeholder="you@example.com"
              required
            />
            <InputText
              label="Phone number"
              id="phone"
              name="phone"
              autoComplete="tel"
              type="tel"
              placeholder="+447700900000"
              required
            />
            <S.CheckboxGroup>
              <S.CheckboxRow>
                <input type="checkbox" name="bollywood" id="bollywood" />
                <div>
                  <strong>Bollywood</strong>
                  <span>Access to Bollywood Movies & Shows</span>
                </div>
              </S.CheckboxRow>
              <S.CheckboxRow>
                <input type="checkbox" name="anime" id="anime" />
                <div>
                  <strong>Anime</strong>
                  <span>Access to Anime Movies & Shows</span>
                </div>
              </S.CheckboxRow>
            </S.CheckboxGroup>
            {message && <FormMessage message={message} />}
            <Button disabled={loading}>{loading ? "..." : "Submit request"}</Button>
          </S.Form>
        )}
      </S.Card>
    </S.Page>
  );
}

export default Register;
